<template>
    <b-modal id="modal-vehicle-switch"
             hide-footer
             centered
             v-model="isVisible"
             :title="$t('cdb.subscriptions.vehicle_switch')"
    >
        <div class="row">
            <div class="col-12">

                <div class="form-group mb-3">
                    <small class="text-muted">{{ $t('cdb.subscriptions.vehicle_switch_info') }}</small>
                </div>

                <b-form-select v-model="data">
                    <b-form-select-option
                        v-for="entry in orderEntriesFiltered"
                        :key="entry.uuid"
                        :value="entry.uuid"
                    >
                        {{ $t(entry.title) }}
                    </b-form-select-option>
                </b-form-select>

            </div>
        </div>
        <div class="row" v-if="error">
            <div class="col-12 text-danger">
                {{ error }}
            </div>
        </div>
        <div class="row mt-3 d-flex justify-content-end">
            <div class="col-12 text-right">
                <b-button variant="primary" class="mr-3" @click="abort">{{ $t('cdb.subscriptions.close') }}</b-button>
                <b-button variant="primary" @click="store" v-if="!isLoading">{{ $t('cdb.subscriptions.vehicle_switch_button') }}</b-button>
                <b-button variant="primary" disabled v-if="isLoading">{{ $t('cdb.subscriptions.loading') }}</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { EventBus } from '../../event-bus';
import { BModal, BButton, BFormSelect, BFormSelectOption } from 'bootstrap-vue';

export default {
    name: 'ModalVehicleSwitch',
    components: {
        BModal,
        BButton,
        BFormSelect,
        BFormSelectOption
    },
    data() {
        return {
            isVisible: false,
            isLoading: false,
            data: '',
            disableSaveButton: false,
            error: '',
            subscription: '',
        }
    },
    mounted() {
        EventBus.$on('init-vehicle-switch', this.getData);
    },
    methods: {
        getData(data) {
            this.isVisible = true
            this.subscription = data
        },

        abort(){
            this.isVisible = false
        },

        store() {
            this.isLoading = true
            this.$axios.put('api/v1/dashboard/update_subscriptions_vehicle_change', {
                    'vehicle_uuid': this.data,
                    'subscription_uuid': this.subscription.uuid
                })
                .then(() => {
                    this.isVisible = false;
                    this.isLoading = false
                    // Reload of the whole Site to reset other Modals too
                    this.$router.go();
                }).catch(error => {
                    this.isLoading = false
                    this.error = error.response.data.message;
            });
        }
    },
    computed: {
        orderEntriesFiltered() {
            return this.subscription.tier_vehicles
        }
    }
}
</script>
